module.exports = __webpack_public_path__ + "img/gb13871-92_70x95x10.prt.9c84f641.jpg";